Namespace 'Monitoring.Models.SocialContents.GoogleMyBusiness.Builders'

class Monitoring.Models.SocialContents.GoogleMyBusiness.Builders.GoogleMyBusinessReviewSnapshotBuilder
  setText: (text) ->
    @text = text

  getText: ->
    @text

  setReviewId: (reviewId) ->
    @reviewId = reviewId

  getReviewId: ->
    @reviewId

  setStarRating: (starRating) ->
    @starRating = starRating

  getStarRating: ->
    @starRating

  setAuthor: (author) ->
    @author = author

  getAuthor: ->
    @author

  setCreatedAt: (createdAt) ->
    @createdAt = createdAt

  getCreatedAt: ->
    @createdAt

  build: ->
    new Monitoring.Models.SocialContents.GoogleMyBusiness.GoogleMyBusinessReviewSnapshot(@)
